module.exports = __webpack_public_path__ + "static/media/news-11.d22e24f2.jpg";